/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */

import { Map as ImmutableMap, Record as ImmutableRecord } from 'immutable';
const SupportLinkTrackingDict = {
  DATA_QUALITY: {
    url: 'https://app.hubspot.com/l/data-quality'
  },
  WHAT_IS_GOAL: {
    url: 'https://knowledge.hubspot.com/articles/KCS_Article/Workflows/What-is-a-Workflow-Goal-and-why-should-I-use-one',
    useZorse: true
  },
  EDIT_DELAY_HELP: {
    url: 'https://knowledge.hubspot.com/articles/KCS_Article/Workflows/What-happens-to-enrolled-contacts-when-I-change-the-timing-of-my-workflow-delays'
  },
  LEARN_ABOUT_WEBHOOKS: {
    url: 'https://knowledge.hubspot.com/workflows/how-do-i-use-webhooks-with-hubspot-workflows'
  },
  LEARN_ABOUT_WEBHOOK_APP_AUTH: {
    url: 'https://knowledge.hubspot.com/workflows/how-do-i-use-webhooks-with-hubspot-workflows#verify-request-signatures-in-workflow-webhooks'
  },
  LEARN_ABOUT_LISTS: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/lists/what-is-the-difference-between-saved-filters-smart-lists-and-static-lists'
  },
  DELETE_FIRST_DELAY: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/workflows/why-cant-i-delete-the-first-delay-in-a-date-based-workflow'
  },
  DELAY_SET_TIME_ACTION_HELP: {
    url: 'https://knowledge.hubspot.com/workflows/use-delays#delay-for-a-set-amount-of-time'
  },
  TEST_BRANCH_HELP: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/workflows/how-do-i-test-branching-logic-in-workflows'
  },
  TEST_WORKFLOW_HELP: {
    url: 'https://knowledge.hubspot.com/workflows-user-guide-v2/how-to-test-your-workflow'
  },
  EMAIL_ACTION_HELP: {
    url: 'https://knowledge.hubspot.com/workflows/workflows-faq#marketing-email'
  },
  WORKFLOWS_USER_GUIDE: {
    url: 'https://knowledge.hubspot.com/workflows/create-workflows',
    useZorse: true
  },
  LEARN_MORE_ABOUT_GOALS: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/workflows/what-is-a-workflow-goal-and-why-should-i-use-one'
  },
  BRANCH_NUMBER_LIMIT: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/workflows/is-there-a-limit-to-the-number-of-branches-i-can-use-in-workflows-branching-logic'
  },
  ASSIGN_USING_CONTACT_PROP: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/contacts/how-can-i-create-a-custom-owner-property'
  },
  LEARN_MORE_ABOUT_ENROLL_EXISTING: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/contacts/enroll-existing-objects-that-meet-enrollment-triggers-in-a-workflow#existing'
  },
  LEARN_MORE_ABOUT_CENTER_ON_DATE: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/workflows/create-center-on-a-date-or-center-on-a-date-property-contact-based-workflows'
  },
  LEARN_MORE_ABOUT_EDITING_PROPERTIES: {
    url: 'https://knowledge.hubspot.com/contacts/manage-your-properties#edit-properties'
  },
  LEARN_MORE_ABOUT_MATCHING_ENUMERABLE_OPTIONS: {
    url: 'https://knowledge.hubspot.com/workflows/compatible-source-and-target-properties-for-copying-property-values-in-workflows#matching-enumeration-options'
  },
  LEARN_MORE_ABOUT_TIME_DELAYS_AND_TIMING_WINDOWS: {
    url: 'https://knowledge.hubspot.com/workflows/manage-your-workflow-settings#set-times-for-actions-to-execute'
  },
  LEARN_MORE_ABOUT_ADD_DATA_SOURCE: {
    url: 'https://knowledge.hubspot.com/workflows/create-workflows#add-actions'
  },
  CREATE_AUDIENCES: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/ads/create-ads-audiences-in-hubspot#contact-list'
  },
  LEARN_MORE_ABOUT_DELAY_UNTIL_DATE: {
    url: 'https://knowledge.hubspot.com/workflows/use-delays'
  },
  LEARN_MORE_ABOUT_WAIT_UNTIL_ACTION: {
    url: 'https://knowledge.hubspot.com/workflows/delay-workflow-until-an-event-happens'
  },
  LEARN_MORE_ABOUT_COPYING_PROPERTIES: {
    url: 'https://knowledge.hubspot.com/workflows/compatible-source-and-target-properties-for-copying-property-values-in-workflows'
  },
  LEARN_MORE_ABOUT_PROPERTY_REQUIREMENTS: {
    url: 'https://knowledge.hubspot.com/crm-setup/set-up-fields-seen-when-manually-creating-records'
  },
  ENROLL_RECORDS_THAT_ALREADY_MEET_CRITERIA: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/contacts/how-to-ensure-existing-contacts-that-meet-a-workflows-starting-condition-are-enrolled-once-the-workflow-is-activated'
  },
  ENROLL_ACTIVE_LIST_MODIFIED: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/workflows/workflows-faq#edit-list'
  },
  ADD_REENROLLMENT_TRIGGERS: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/workflows/how-do-i-add-re-enrollment-triggers-to-a-workflow-to-allow-contacts-to-be-enrolled-in-a-workflow-multiple-times'
  },
  OBJECT_IN_INACTIVE_WORKFLOW: {
    url: 'https://knowledge.hubspot.com/workflows/turn-off-workflows#impact-on-objects-in-a-workflow-that-is-turned-off'
  },
  CENTER_ON_DATE_WORKFLOW: {
    url: 'https://knowledge.hubspot.com/workflows/understand-contact-based-workflow-types#center-on-a-date'
  },
  MANAGE_SUBSCRIPTION_PREFERENCES: {
    url: 'https://knowledge.hubspot.com/contacts/manage-your-subscription-preferences-and-types?KBOpenTab#workflow'
  },
  SYNC_CONTACT_TO_SALESFORCE: {
    url: 'https://knowledge.hubspot.com/salesforce/salesforce-integration-sync-triggers#contact-not-syncing-to-salesforce'
  },
  SEND_EMAIL_ACTION: {
    url: 'https://knowledge.hubspot.com/workflows/choose-your-workflow-actions#send-email'
  },
  GET_HELP_WITH_HUBSPOT: {
    url: 'https://knowledge.hubspot.com/account/get-help-with-hubspot'
  },
  WORKFLOWS_FAQ_DELAYS: {
    url: 'https://knowledge.hubspot.com/workflows/workflows-faq#delays'
  },
  UPDATE_LIFECYCLE_STAGE: {
    url: 'https://knowledge.hubspot.com/contacts/use-lifecycle-stages#how-do-i-update-the-lifecycle-stage-property'
  },
  ASSOCIATE_RECORDS: {
    url: 'https://knowledge.hubspot.com/crm-setup/associate-records'
  },
  SUPPRESS_CONTACTS: {
    url: 'https://knowledge.hubspot.com/workflows/manage-your-contact-based-workflow-settings#when-a-contact-no-longer-meets-the-enrollment-conditions-remove-them-from-this-workflow'
  },
  SYNC_OWNERSHIP: {
    url: 'https://knowledge.hubspot.com/contacts/sync-ownership-between-contacts-and-companies'
  },
  TEST_PLATFORM_WORKFLOW: {
    url: 'https://knowledge.hubspot.com/workflows/test-your-company-deal-ticket-quote-based-workflow#test-actions'
  },
  ADD_USERS_TO_TASK_QUEUE: {
    url: 'https://knowledge.hubspot.com/tasks/use-task-queues#add-other-users-to-an-existing-task-queue'
  },
  TURN_OFF_WORKFLOWS: {
    url: 'https://knowledge.hubspot.com/workflows/turn-off-workflows'
  },
  MARKETING_CONTACTS: {
    url: 'https://knowledge.hubspot.com/contacts/marketing-contacts'
  },
  SET_CONTACT_AS_MARKETING: {
    url: 'https://knowledge.hubspot.com/contacts/set-contacts-as-marketing'
  },
  COMPATIBLE_PROPERTIES: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/workflows/why-am-i-unable-to-select-my-target-property-when-copying-properties-using-a-workflow'
  },
  HOW_TO_ROTATE_OWNER: {
    url: 'https://knowledge.hubspot.com/articles/kcs_article/contacts/how-to-set-an-owner#rotate'
  },
  DATE_CENTERED_WORKFLOWS: {
    url: 'https://knowledge.hubspot.com/workflows/understand-contact-based-workflow-types#center-on-a-date'
  },
  FORMAT_DATA_WORKFLOW_ACTION: {
    url: 'https://knowledge.hubspot.com/workflows/format-your-data-with-workflows'
  },
  CUSTOM_CODE_DEVELOPER: {
    url: 'https://developers.hubspot.com/docs/api/workflows/custom-code-actions'
  },
  CUSTOM_CODE_HELP: {
    url: 'https://developers.hubspot.com/docs/api/workflows/custom-code-actions'
  },
  CUSTOM_CODE_EXAMPLE: {
    url: 'https://www.hubspot.com/programmable-automation-use-cases'
  },
  BRANCH_ACTIONS_IN_WORKFLOWS: {
    url: 'https://knowledge.hubspot.com/workflows/use-if-then-branches-in-workflows'
  },
  RELAXED_VALIDATION: {
    url: 'https://knowledge.hubspot.com/workflows/save-placeholder-workflow-actions'
  },
  PERSONALIZE_YOUR_CONTENT: {
    url: 'https://knowledge.hubspot.com/website-pages/personalize-your-content'
  },
  DEACTIVATED_USER: {
    url: 'https://knowledge.hubspot.com/settings/deactivate-hubspot-users'
  },
  SCHEDULED_TRIGGERS: {
    url: 'https://knowledge.hubspot.com/workflows/create-a-scheduled-trigger-workflow'
  },
  ACTIVE_ENROLLED_SUNSET: {
    url: 'https://knowledge.hubspot.com/workflows/understand-your-workflow-details-page#:~:text=Please%20note%3A%20the%20Active%20Enrolled%20metric'
  },
  EMAIL_BLOCKED_BY_HUBSPOT: {
    url: "https://knowledge.hubspot.com/workflows/troubleshoot-common-workflow-errors#common-workflow-errors:~:text=This%20email%20wasn't%20sent%20because%20it%20is%20being%20blocked%20by%20HubSpot"
  },
  MERGE_CONTACTS: {
    url: 'https://knowledge.hubspot.com/contacts/how-do-i-merge-contacts#what-happens-when-i-merge-two-contacts'
  },
  MERGE_COMPANIES: {
    url: 'https://knowledge.hubspot.com/companies/how-do-i-merge-companies#what-happens-when-i-merge-two-companies'
  },
  MERGE_DEALS: {
    url: 'https://knowledge.hubspot.com/deals/merge-deals#what-happens-when-i-merge-two-deals'
  },
  MERGE_TICKETS: {
    url: 'https://knowledge.hubspot.com/tickets/merge-tickets#what-happens-when-i-merge-two-tickets'
  },
  MERGE_CUSTOM_OBJECTS: {
    url: 'https://knowledge.hubspot.com/crm-setup/use-custom-objects#:~:text=Merge%20custom%20object%20records'
  },
  OPTIMIZE: {
    url: 'https://knowledge.hubspot.com/workflows/use-if-then-branches-in-workflows#clean-up-your-branches'
  },
  LEARN_MORE_ABOUT_WORKFLOW_USAGE_LIMIT: {
    url: 'https://knowledge.hubspot.com/workflows/workflows-faq#which-workflows-count-towards-my-hubspot-account-limits'
  },
  SANDBOX_ENROLLMENT_LIMITS: {
    url: 'https://knowledge.hubspot.com/account/sync-automated-emails-forms-lists-and-workflows-to-a-standard-sandbox-account'
  },
  DEVELOPER_ENROLLMENT_LIMITS: {
    url: 'https://developers.hubspot.com/docs/api/account-types'
  },
  EMAIL_CANCELLED_ABUSE: {
    url: 'https://knowledge.hubspot.com/email/why-was-my-email-send-stopped'
  },
  HOW_TO_ENABLE_NOTIFICATIONS: {
    url: 'https://knowledge.hubspot.com/settings/how-to-set-up-user-notifications-in-hubspot#email:~:text=visit%20your%20website.-,Workflows,-%3A%20receive%20notifications'
  },
  BUSINESS_UNITS_IN_WORKFLOWS_TIPS: {
    url: 'https://knowledge.hubspot.com/workflows/organize-your-workflows#assign-business-units-to-your-workflows-beta'
  },
  LEARN_MORE_ABOUT_EXECUTION_TIMING: {
    url: 'https://knowledge.hubspot.com/workflows/manage-your-workflow-settings#timing'
  },
  LEARN_MORE_ABOUT_ASK_BREEZE: {
    url: 'https://knowledge.hubspot.com/workflows/use-ai-to-manage-data-in-workflows#use-the-ask-breeze-workflow-action'
  }
};

// Nice trick: https://fettblog.eu/typescript-union-to-intersection/

/**
The goal here is to come up with a value for all possible fields. By default indexing into the
values of an object with result in a union type of all possible values, where in this case we
want an intersection type where each property is a union of all the possible values it can take.

For example, we want to take a type of

```
{
  url: 'hello.com',
  useZorse: true
} | {
  url: 'goodbye.com',
  useZorse: false
}
```

and turn it into

```
{
  url: 'hello.com' | 'goodbye.com',
  useZorse: true | false
}
```
 */
export const SupportLinkKeys = Object.fromEntries(Object.keys(SupportLinkTrackingDict).map(key => [key, key]));
class SupportLinkMetaData extends ImmutableRecord({
  url: '',
  useZorse: false
}, 'SupportLinkMetaData') {}
export const SupportLinks = ImmutableMap(Object.keys(SupportLinkKeys).map(key => [key, new SupportLinkMetaData(SupportLinkTrackingDict[key])]));